import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import { authReducer } from './modules/Auth/store/reducer';
import {reducer as toastrReducer} from 'react-redux-toastr'

const reducers = combineReducers({
    auth: authReducer,
    toastr: toastrReducer
})

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    reducers,
    composeEnhancers(applyMiddleware(thunk))    
);

export default store;
